const defaultFonts = [
  'NotoSansSC-Black.woff',
  'NotoSansSC-Bold.woff',
  'NotoSansSC-Demilight.woff',
  'NotoSansSC-Light.woff',
  'NotoSansSC-Medium.woff',
  'NotoSansSC-Regular.woff',
  'NotoSansSC-Thin.woff',
];

const nanumFonts = [
  'NanumSquareNeoOTF-aLt.woff',
  'NanumSquareNeoOTF-bRg.woff',
  'NanumSquareNeoOTF-cBd.woff',
  'NanumSquareNeoOTF-dEb.woff',
  'NanumSquareNeoOTF-eHv.woff',
];

export const loadDefaultFonts = () => {
  defaultFonts.forEach((font, index) => {
    let elHead, elLink;

    elLink = document.createElement('link');
    elLink.rel = 'preload';
    elLink.as = 'font';
    elLink.type = 'font/woff';
    elLink.href = `./fonts/${defaultFonts[index]}`;
    elLink.crossOrigin = 'anonymous';

    elHead = document.getElementsByTagName('head')[0];
    elHead.appendChild(elLink);
  });
  let elBody = document.getElementsByTagName('body')[0];
  elBody.style.setProperty('--default-font-family', 'NotoSans');
};

export const loadKrFonts = () => {
  nanumFonts.forEach((font, index) => {
    let elHead, elLink, elBody;

    elLink = document.createElement('link');
    elLink.rel = 'preload';
    elLink.as = 'font';
    elLink.type = 'font/woff';
    elLink.href = `./fonts/${nanumFonts[index]}`;
    elLink.crossOrigin = 'anonymous';

    elHead = document.getElementsByTagName('head')[0];
    elHead.appendChild(elLink);
  });
  let elBody = document.getElementsByTagName('body')[0];
  elBody.style.setProperty('--default-font-family', 'NanumSquareNeoOTF-bRg');
  elBody.setAttribute('class', 'word-break-keep-all');
};

export const getFontsByCountry = () => {
  const browserLanguage = navigator.language;
  if (browserLanguage === 'ko') {
    loadKrFonts();
  } else {
    loadDefaultFonts();
  }
};
